import { Media } from 'react-bootstrap'
import Link from 'next/link'

function StripEO({title, desc, image, link, btnText, themeColor, customclass, imgsize}) {
    return (
        <>
            <Media className="m-3 flex-1">
                <img
                    width={imgsize}
                    className="mr-3 img-fluid imgItem"
                    src={image}
                    alt={title}
                />
                <Media.Body className={`${customclass} h7`}>
                    <div className="flex-1">
                        <h5 className="h5">{title}</h5>
                        <p className="h6 font-weight-normal lh-1-5 mb-3">{desc}</p>
                    </div>
                    {
                        link.includes("//") ? 
                        <a href={link} className={`${themeColor} rounded-pill p-2 px-4 h7 d-inline-block`}>{btnText}</a>
                        :
                        <Link href={link}><a className={`${themeColor} rounded-pill p-2 px-4 h7 d-inline-block`}>{btnText}</a></Link>
                    }
                </Media.Body>
            </Media>
            <style jsx>
                {`
                    h5{
                        font-weight: 600;
                    }
                   @media(max-width:767px){
                       .imgItem{
                           width:60px;
                       }
                   }
                `}
            </style>
        </>
       
    )
}

                

export default StripEO
